import { ImageElementType } from 'polotno/model/image-model';
import { AvatarView } from '../ViewControl';

export const getMaskingType = (element: ImageElementType | undefined) => {
    if (!element) return null;

    if (element.custom.view === AvatarView.Full && !element.custom.viewModified) return 'default-full';

    return element.custom.view;
};
